import React, { useEffect, useState } from "react";

// components
import MaterialButton, { ButtonProps } from "@mui/material/Button";

// styles
import styles from "./styles.module.css";
import classNames from "classnames";

export enum ButtonType {
  DEFAULT = "DEFAULT",
  OUTLINED = "OUTLINED",
  DISABLED = "DISABLED",
}
interface Props extends ButtonProps {
  Icon?: ButtonProps["startIcon"];
  buttonType?: ButtonType;
}

const Button: React.FC<Props> = ({
  Icon,
  buttonType = ButtonType.DEFAULT,
  children,
  ...props
}: Props): JSX.Element => {
  const [buttonStyle, setButtonStyle] = useState<ButtonType>(
    ButtonType.DEFAULT
  );

  useEffect(() => {
    if (props.disabled) {
      setButtonStyle(ButtonType.DISABLED);
    } else {
      setButtonStyle(buttonType);
    }
  }, [buttonType, props.disabled]);

  return (
    <MaterialButton
      className={classNames(
        styles["container"],
        buttonStyle === ButtonType.DEFAULT && styles["default"],
        buttonStyle === ButtonType.OUTLINED && styles["outlined"],
        buttonStyle === ButtonType.DISABLED && styles["disabled"],
        props.size === "small" && styles["small"]
      )}
      variant="contained"
      startIcon={Icon ? Icon : ""}
      {...props}>
      {children}
    </MaterialButton>
  );
};

export default Button;
